import React from 'react'
import { WidgetContent } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import styled from '@emotion/styled'

const ContainerWrapper = styled(WidgetContent)`
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
`

const LabelContainer = styled.div`
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
`

const LabelText = styled.span`
  font-size: 12px;
  color: #9ea0a5;
`

const Container = styled.div`
  padding-top: 26px;
  display: flex;
  flex-direction: column;
`

const StyledTextArea = styled.textarea`
  height: 285px;
  resize: none;
  padding: 16px;
  border: 1px solid #eaedf3;
`

const ButtonContainer = styled(WidgetContent)`
  display: flex;
  justify-content: flex-end;
  border: none;
  width: 482px;
`
const ButtonWrapper = styled.div`
  display: flex;
`

const ButtonDiv = styled.div`
  width: 83px;
`

const CancelDispatch = ({
  cancelDispatch,
  setCancelledNotes,
  cancelledNotes,
  handleCloseModal
}) => {
  return (
    <CreateNewModal
      title="Cancel Dispatch"
      bannerText="Add an optional note to drivers and dispatchers"
      handleCloseModal={handleCloseModal}
    >
      <ContainerWrapper>
        <Container>
          <LabelContainer>
            <LabelText>NOTE</LabelText>
            <LabelText>(optional)</LabelText>
          </LabelContainer>
          <StyledTextArea
            className="fullWidthInputBox uik-input__input"
            label="Notes"
            name="notes"
            value={cancelledNotes}
            onChange={e => setCancelledNotes(e.target.value)}
          />
        </Container>
      </ContainerWrapper>
      <ButtonWrapper>
        <ButtonContainer>
          <ButtonDiv>
            <ModalButton success backgroundcolor="#38B249" name="Ok" onClick={cancelDispatch} />
          </ButtonDiv>
        </ButtonContainer>
      </ButtonWrapper>
    </CreateNewModal>
  )
}

export default CancelDispatch
